<template>
    <!-- ------------------------------------- 博客 ----------------------------------- -->
    <div class="blog">
        <!-- ---------------------------------- 顶部导航栏 ---------------------------------- -->
        <Header></Header>
        <!-- ---------------------------------- 海报图 ---------------------------------- -->
        <!-- <div class="banner"> </div> -->

        <!-- ---------------------------------- 文章 ---------------------------------- -->
        <div class="article">
            <!-- 主文章 -->
            <div class="article_main">
                <!-- <div>
                    <h1 @click="toIndex()">首页 </h1>
                  </div> -->
                <div>
                    <h1>关于我们</h1>
                    <div style="border-bottom: 1.5px solid #bcbcbc">
                        <div
                            style="
                                border-bottom: 1.5px solid #24355a;
                                width: 15%;
                                position: absolute;
                            "
                        ></div>
                    </div>
                    <div class="zi-title" @click="toAbout()">公司简介</div>
                    <div class="zi-title-1" @click="toAbout()">品牌故事</div>
                    <div class="zi-title-2">
                        <div>念 | WE THINK ···</div>
                        <div>始 | WE BEGIN ···</div>
                        <div>创 | WE CREATE ···</div>
                    </div>
                </div>

                <div>
                    <h1>AIR</h1>
                    <div style="border-bottom: 1.5px solid #bcbcbc">
                        <div
                            style="
                                border-bottom: 1.5px solid #192c54;
                                width: 15%;
                                position: absolute;
                            "
                        ></div>
                    </div>
                    <div class="zi-title" @click="toAir()">
                        RA 488 高效空气净化器
                    </div>
                    <div class="zi-title-3">
                        <div>有关产品</div>
                        <div>过滤净化功能</div>
                        <div>产品特点</div>
                    </div>
                    <div class="zi-title-3">
                        <div>服务介绍</div>
                        <div>规格</div>
                        <div>检测</div>
                    </div>
                    <div class="zi-title-3">
                        <div>过滤配件</div>
                        <div>其他</div>
                        <div>咨询</div>
                    </div>

                    <div class="zi-title" @click="toAir(1)">
                        RA 800 高效空气净化器
                    </div>
                    <div class="zi-title-3">
                        <div>有关产品</div>
                        <div>过滤净化功能</div>
                        <div>产品特点</div>
                    </div>
                    <div class="zi-title-3">
                        <div>服务介绍</div>
                        <div>规格</div>
                        <div>检测</div>
                    </div>
                    <div class="zi-title-3">
                        <div>过滤配件</div>
                        <div>其他</div>
                        <div>咨询</div>
                    </div>

                    <!-- <div class="zi-title" @click="toAir(2)">
                        PN-02B/W 等离子纳米空气净化器
                    </div>
                    <div class="zi-title-3">
                        <div>有关产品</div>
                        <div>过滤净化功能</div>
                        <div>服务介绍</div>
                    </div>
                    <div class="zi-title-3">
                        <div>规格</div>
                        <div>检测</div>
                        <div>过滤配件</div>
                    </div>
                    <div class="zi-title-4">
                        <div>其他</div>
                        <div>咨询</div>
                    </div> -->
                </div>
                <div>
                    <h1>CARE</h1>
                    <div style="border-bottom: 1.5px solid #bcbcbc">
                        <div
                            style="
                                border-bottom: 1.5px solid #192c54;
                                width: 15%;
                                position: absolute;
                            "
                        ></div>
                    </div>

                    <div class="zi-title" @click="toCare(0)">净化清洁服务</div>
                    <div class="zi-title-3">
                        <div>咨询服务</div>
                        <div>为何要更换滤网</div>
                        <div>5C服务清单服务内容</div>
                    </div>
                    <div class="zi-title" @click="toCare(1)">
                        合约期外保养服务
                    </div>
                    <div class="zi-title-4">
                        <div>咨询服务</div>
                    </div>
                </div>
                <div>
                    <h1>2D体验馆</h1>
                    <div style="border-bottom: 1.5px solid #bcbcbc">
                        <div
                            style="
                                border-bottom: 1.5px solid #192c54;
                                width: 15%;
                                position: absolute;
                            "
                        ></div>
                    </div>
                    <div class="zi-title-4" style="margin-top: 3%">
                        <div @click="toExperience()">2D体验馆</div>
                    </div>
                </div>
                <div>
                    <h1>预约空气检测</h1>
                    <div style="border-bottom: 1.5px solid #bcbcbc">
                        <div
                            style="
                                border-bottom: 1.5px solid #192c54;
                                width: 15%;
                                position: absolute;
                            "
                        ></div>
                    </div>
                    <div class="zi-title1" @click="toDetection()">服务咨询</div>
                    <div class="zi-title1" @click="toDetection()">检测范围</div>
                    <div class="zi-title1" @click="toDetection()">用家体验</div>
                    <div class="zi-title1" @click="toDetection()">一步预约</div>
                </div>
                <div>
                    <h1>企业资讯</h1>
                    <div style="border-bottom: 1.5px solid #bcbcbc">
                        <div
                            style="
                                border-bottom: 1.5px solid #192c54;
                                width: 15%;
                                position: absolute;
                            "
                        ></div>
                    </div>
                    <div class="zi-title1" @click="toInfo()">企业资讯</div>
                </div>
                <div>
                    <h1>加入我们</h1>
                    <div style="border-bottom: 1.5px solid #bcbcbc">
                        <div
                            style="
                                border-bottom: 1.5px solid #192c54;
                                width: 15%;
                                position: absolute;
                            "
                        ></div>
                    </div>
                    <div class="zi-title1" @click="toJoin()">
                        为什么选择蔚诺
                    </div>
                    <div class="zi-title1" @click="toJoin()">分销商流程</div>
                    <div class="zi-title1" @click="toJoin()">代理商流程</div>
                    <div class="zi-title1" @click="toJoin()">产品应用场景</div>
                    <div class="zi-title1" @click="toJoin()">
                        分销商条件及费用
                    </div>
                </div>
                <div>
                    <h1>订阅我们</h1>
                    <div style="border-bottom: 1.5px solid #bcbcbc">
                        <div
                            style="
                                border-bottom: 1.5px solid #192c54;
                                width: 15%;
                                position: absolute;
                            "
                        ></div>
                    </div>
                    <div class="zi-title1" @click="toSubscribe()">订阅我们</div>
                </div>
                <div>
                    <h1>博客</h1>
                    <div style="border-bottom: 1.5px solid #bcbcbc">
                        <div
                            style="
                                border-bottom: 1.5px solid #192c54;
                                width: 15%;
                                position: absolute;
                            "
                        ></div>
                    </div>
                    <div class="zi-title1" @click="toBlog()">蔚诺文章</div>
                </div>
            </div>
            <!-- 副文章 -->
        </div>
        <!-- ---------------------------------- 底部栏 ---------------------------------- -->
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/Header';
import Footer from '@/components/Footer';

export default {
    data() {
        return {
            activeNames: ['1'],
        };
    },
    components: {
        Header,
        Footer,
    },

    methods: {
        // 跳转文章详情
        toBlog() {
            this.$router.push({
                path: '/blog',
            });
        },
        toSubscribe() {
            this.$router.push({
                path: '/subscribe',
            });
        },
        //   toSubscribe() {
        //     this.$router.push({
        //         path: "/join",
        //     });
        // },
        toInfo() {
            this.$router.push({
                path: '/news',
            });
        },
        toDetection() {
            this.$router.push({
                path: '/airtest',
            });
        },
        toExperience() {
            this.$router.push({
                path: '/experience',
            });
        },
        toCare(cur) {
            this.$router.push({
                name: 'care',
                params: { cur: cur },
            });
        },
        toAir(tabId) {
            if (tabId) {
                this.$router.push({
                    name: 'air',
                    params: { tabId: tabId },
                });
            } else {
                this.$router.push({
                    path: '/air',
                });
            }
        },
        toAbout() {
            this.$router.push({
                path: '/about',
            });
        },
        toIndex() {
            this.$router.push({
                path: '/index',
            });
        },
        toJoin() {
            this.$router.push({
                path: '/join',
            });
        },
    },
};
</script>

<style lang="less" scoped>
* {
    font-family: Microsoft YaHei;
}
.banner {
    width: 100%;
    height: 687px;
    background: url('../assets/images/banner-pre.png') no-repeat;
    background-size: 100% 100%;
    background-position: center;
    position: relative;
    p {
        font-size: 70px;
        color: #ffffff;
        letter-spacing: 10px;
        font-weight: lighter;
        margin: 0;
        position: absolute;
        bottom: 37%;
        right: 12%;
    }
}
// ---------------------------- 招聘信息 ---------------------------------
// ------------- mobile端样式 -------------
@media only screen and (max-width: 960px) {
    // 屏幕小于960px
    // 主文章
    .article_main {
        width: 80%;
        // 文章标题
        h1 {
            font-size: 64px;
            padding-top: 3%;
        }
        .zi-title {
            font-size: 58px;
            margin: 4% 0;
        }
        .zi-title-1 {
            font-size: 52px;
        }
        .zi-title-2 {
            font-size: 46px;
        }
        .zi-title-3 {
            font-size: 46px;
        }
        .zi-title-4 {
            font-size: 46px;
        }
        .zi-title1 {
            font-size: 48px;
        }
    }
}
// ------------- pc端样式 -------------
@media only screen and (min-width: 960px) {
    // 屏幕大于960px
    // 主文章
    .article_main {
        width: 60%;
        // 文章标题
        h1 {
            font-size: 30px;
            padding-top: 1%;
        }
        .zi-title {
            font-size: 25px;
            margin: 2% 0;
        }
        .zi-title-1 {
            font-size: 25px;
        }
        .zi-title-2 {
            font-size: 22px;
        }
        .zi-title-3 {
            font-size: 22px;
        }
        .zi-title-4 {
            font-size: 22px;
        }
        .zi-title1 {
            font-size: 25px;
        }
    }
}

.article {
    width: 100%;
    margin: 0 auto;
    padding: 80px 0 60px 0;
    display: flex;
    justify-content: space-between;
    font-family: '等线';
    // 主文章
    .article_main {
        margin: 0 auto;
        // 文章标题
        .zi-title {
            cursor: pointer;
            color: #112653;
        }
        .zi-title-1 {
            cursor: pointer;
            color: #112653;
        }
        .zi-title-2 {
            width: 90%;
            display: flex;
            margin-top: 3%;
            margin-bottom: 2%;
            div {
                flex: 1;
                color: #000;
            }
        }
        .zi-title-3 {
            width: 90%;
            display: flex;
            margin-top: 1%;
            margin-bottom: 2%;
            div {
                flex: 1;
                color: #000;
            }
        }
        .zi-title-4 {
            width: 60%;
            display: flex;
            margin-top: 1%;
            margin-bottom: 2%;
            div {
                flex: 1;
                cursor: pointer;
                color: #000;
            }
        }
        .zi-title1 {
            margin-top: 2%;
            margin-bottom: 2%;
            color: #112653;
            cursor: pointer;
        }

        .article_title {
            border: 1px solid #bcbcbc;
            background: #efeeed;
            color: #192c54;
            letter-spacing: 2px;
            margin: 0;
            cursor: pointer;
        }
        // 文章信息
        .article_information {
            width: 100%;
            margin: 10px 0 30px 0;
            p {
                color: #333;
            }
            .neirong {
                width: 90%;
                margin: auto;
                margin-top: 3%;
            }
        }
    }
}

/deep/ .el-collapse {
    // border: 0.005208rem solid #bcbcbc;
    background: #efeeed;
}
/deep/ .el-collapse-item__header {
    font-family: Microsoft YaHei;
    font-size: 32px;
    height: 60px;
    border-radius: 16px 16px 16px 16px;
    background: #efeeed;
    background: #efeeed;
    font-weight: 600;
    color: #192c54;
    letter-spacing: 2px;
    margin: 0;
    cursor: pointer;
    padding-left: 2%;
}
/deep/ .el-collapse {
    border: 1px solid #bcbcbc;
    border-radius: 16px;
    margin-top: 15px;
}
/deep/ .el-collapse-item__wrap {
    font-size: 18px;
    border-radius: 0 0 16px 16px;
    background: #fafafb;
    font-weight: 600;
    color: #192c54;
    letter-spacing: 2px;
    margin: 0;
    cursor: pointer;
    border-top: 1px solid #bcbcbc;
    /*padding-left: 1%;*/
}
</style>



// WEBPACK FOOTER //
// src/view/websiteMap.vue